import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useFeatureFlags } from 'ha/modules/FeatureFlags';
import { FeaturedCountries } from 'ha/constants/FeaturedCountries';
import { getSelectedVariants } from 'ha/modules/Experiments/selectors';
import EXPERIMENTS from 'ha/constants/experiments';

import { getCountryCode } from '../selectors';

const useIsTravelTimeEnabled = () => {
  const { searchPageTravelTime } = useFeatureFlags();
  const countryCode = useSelector(getCountryCode);
  const travelTimeExperimentVariant =
    useSelector(getSelectedVariants)[EXPERIMENTS.HA7595.name];

  const shouldEnableTravelTimeExperiment = useMemo(
    () =>
      searchPageTravelTime === 'on' && FeaturedCountries.includes(countryCode),
    [searchPageTravelTime, countryCode],
  );

  const isTravelTimeEnabled = useMemo(
    () =>
      shouldEnableTravelTimeExperiment && travelTimeExperimentVariant === 'B',
    [shouldEnableTravelTimeExperiment, travelTimeExperimentVariant],
  );

  return {
    shouldEnableTravelTimeExperiment,
    isTravelTimeEnabled,
  };
};

export default useIsTravelTimeEnabled;
